export default {
    generateContentModal: {
        title: 'Inhalt generieren',
        type: 'Typ',
        typePlaceholder: 'Typ auswählen',
        typeEmptyError: 'Bitte wählen Sie den Typ',
        context: 'Kontext',
        contextPlaceholder: 'Kontext auswählen',
        contextEmptyError: 'Bitte wählen Sie den Kontext',
        contentTitle: 'Titel des Inhalts',
        contentTitlePlaceholder: 'Fügen Sie das Thema Ihres Inhalts hinzu',
        contentTitleEmptyError: 'Bitte geben Sie den Titel ein',
        contentTitleInvalidError: 'Bitte geben Sie einen gültigen Titel ein',
        description: 'Geben Sie eine kurze Inhaltsbeschreibung ein',
        descriptionPlaceholder: 'Fügen Sie die Beschreibung Ihres Inhalts in 2-3 Zeilen ein',
        descriptionEmptyError: 'Bitte geben Sie die Beschreibung ein',
        descriptionInvalidError: 'Bitte geben Sie eine gültige Beschreibung ein',
        addKeywords: 'Schlüsselwörter hinzufügen',
        addKeywordsEmptyError: 'Bitte geben Sie die Schlüsselwörter ein',
        writingTone: 'Schreibton',
        writingTonePlaceholder: 'Schreibstil auswählen',
        writingToneEmptyError: 'Bitte wählen Sie den Schreibstil',
        numberOfVariations: 'Anzahl der Variationen',
        numberOfVariationsEmptyError: 'Bitte wählen Sie die Anzahl der Variationen',
        numberOfVariationsInvalidError: 'Sie können maximal 5 und mindestens 1 Variation erzeugen.',
        generate: 'Erzeugen',
        additionalOptions: 'Zusätzliche Optionen',
        clear: 'Übersichtlich',
        writingToneOptions: {
            funny: 'Lustig',
            casual: 'Lässig',
            excited: 'Aufgeregt',
            professional: 'Professionell',
            witty: 'Witzig',
            sarcastic: 'Sarkastisch',
            feminine: 'Weiblich',
            masculine: 'Männlich',
            bold: 'Kühn',
            dramatic: 'Dramatisch',
            grumpy: 'Mürrisch',
            secretive: 'Geheimnisvoll',
            respectful: 'Rücksichtsvoll',
            persuasive: 'Überzeugend',
        },
        contextOptions: {
            promotional: 'Werbend',
            introduction: 'Einführung',
            couponDiscount: 'Coupon/Rabatt',
            recurringNewsletter: 'Wiederkehrender Newsletter',
            testimonial: 'Testimonial',
            coldOutreach: 'Kaltakquise',
            contentGiveaway: 'Inhalt/Geschenkartikel',
            other: 'Sonstiges',
        },
        typeOptions: {
            outline: 'Gliederung',
            introduction: 'Einführung',
            section: 'Abschnitt',
        },
    },
};
